import { useEffect } from "react";

export function Terms() {
  const siteName = "אתר עו״ד ארז עזרא";
  const ownerName = "עו״ד ארז עזרא";
  const lastUpdated = "11/03/2026";

  useEffect(() => {
    document.title = "תנאי שימוש | עו״ד ארז עזרא";
  }, []);

  return (
    <main
      id="main"
      aria-labelledby="terms-title"
      className="min-h-screen bg-gradient-to-b from-slate-950 via-slate-900 to-black text-slate-200 pt-32 pb-20"
    >
      <a
        href="/"
        aria-label="חזרה לדף הבית"
        className="fixed top-6 right-6 z-[9999] inline-flex items-center gap-2
             px-5 py-2.5 rounded-full
             bg-slate-800/80 text-slate-100
             backdrop-blur-md border border-white/10
             hover:bg-slate-700 transition-all duration-300
             focus-visible:ring-2 focus-visible:ring-blue-500"
      >
        ← חזרה לאתר
      </a>

      <div className="container mx-auto px-6 max-w-4xl">
        <header className="mb-14 text-center md:text-right">
          <h1
            id="terms-title"
            className="text-4xl md:text-5xl font-bold tracking-tight mb-4 text-white"
          >
            תנאי שימוש
          </h1>
          <p className="text-slate-400 text-lg">
            עודכן לאחרונה: <strong>{lastUpdated}</strong>
          </p>
        </header>

        <div className="space-y-12 text-lg leading-relaxed">
          {/* כללי */}
          <section aria-labelledby="terms-general">
            <h2 id="terms-general" className="sr-only">
              כללי
            </h2>
            <p className="text-slate-300">
              השימוש באתר {siteName} כפוף לתנאים המפורטים במסמך זה. גלישה ושימוש
              באתר מהווים הסכמה לתנאים אלו.
            </p>
          </section>

          {/* שימוש באתר */}
          <section aria-labelledby="terms-usage">
            <h2
              id="terms-usage"
              className="text-2xl font-semibold text-white mb-3"
            >
              שימוש באתר
            </h2>

            <p className="text-slate-300">
              המשתמש מתחייב לעשות שימוש באתר בהתאם להוראות הדין בלבד ולהימנע
              מפעולות העלולות לפגוע בפעילות האתר, במשתמשים אחרים או בבעל האתר.
            </p>
          </section>

          {/* אי מתן ייעוץ משפטי */}
          <section aria-labelledby="terms-no-legal-advice">
            <h2
              id="terms-no-legal-advice"
              className="text-2xl font-semibold text-white mb-3"
            >
              אי מתן ייעוץ משפטי
            </h2>
            <p className="text-slate-300">
              התוכן המופיע באתר נועד למידע כללי בלבד ואינו מהווה ייעוץ משפטי,
              חוות דעת משפטית או תחליף לייעוץ מקצועי פרטני. לכל מקרה משפטי יש
              לפנות לייעוץ אישי בהתאם לנסיבות הספציפיות.
            </p>
          </section>

          {/* העדר יחסי עורך דין–לקוח */}
          <section aria-labelledby="terms-no-attorney-client">
            <h2
              id="terms-no-attorney-client"
              className="text-2xl font-semibold text-white mb-3"
            >
              העדר יחסי עורך דין–לקוח
            </h2>

            <p className="text-slate-300">
              השימוש באתר או שליחת פנייה באמצעות טופס יצירת הקשר אינם יוצרים
              יחסי עורך דין–לקוח בין המשתמש לבין {ownerName}. יחסים משפטיים
              כאמור ייווצרו רק לאחר פנייה ישירה והסכמה מפורשת בין הצדדים.
            </p>
          </section>

          {/* אחריות */}
          <section aria-labelledby="terms-liability">
            <h2
              id="terms-liability"
              className="text-2xl font-semibold text-white mb-3"
            >
              אחריות
            </h2>
            <p className="text-slate-300">
              השימוש באתר הינו באחריות המשתמש בלבד. בעל האתר אינו אחראי לנזקים
              ישירים או עקיפים העלולים להיגרם כתוצאה מהשימוש באתר או מהסתמכות על
              המידע המופיע בו.
            </p>

            <p className="text-slate-300">
              בעל האתר אינו מתחייב כי המידע המופיע באתר יהיה מלא, מדויק או
              מעודכן בכל עת.
            </p>
          </section>

          {/* קניין רוחני */}
          <section aria-labelledby="terms-intellectual">
            <h2
              id="terms-intellectual"
              className="text-2xl font-semibold text-white mb-3"
            >
              קניין רוחני
            </h2>
            <p className="text-slate-300">
              כל התכנים באתר, לרבות טקסטים, עיצוב, גרפיקה וקוד, שייכים ל־
              {ownerName} או לבעלי הזכויות הרלוונטיים. אין להעתיק, להפיץ, לשכפל
              או לעשות שימוש בתוכן ללא אישור מראש ובכתב.
            </p>
          </section>

          {/* קישורים חיצוניים */}
          <section aria-labelledby="terms-links">
            <h2
              id="terms-links"
              className="text-2xl font-semibold text-white mb-3"
            >
              קישורים חיצוניים
            </h2>

            <p className="text-slate-300">
              האתר עשוי לכלול קישורים לאתרים חיצוניים לנוחות המשתמש בלבד. בעל
              האתר אינו אחראי לתוכן המופיע באתרים אלו או למדיניות הפרטיות שלהם.
            </p>
          </section>

          {/* שינויים */}
          <section aria-labelledby="terms-changes">
            <h2
              id="terms-changes"
              className="text-2xl font-semibold text-white mb-3"
            >
              שינויים בתנאים
            </h2>
            <p className="text-slate-300">
              הנהלת האתר רשאית לעדכן תנאים אלו מעת לעת לפי שיקול דעתה. מועד
              העדכון האחרון מצוין בראש מסמך זה.
            </p>
          </section>

          {/* דין וסמכות שיפוט */}
          <section aria-labelledby="terms-law">
            <h2
              id="terms-law"
              className="text-2xl font-semibold text-white mb-3"
            >
              דין וסמכות שיפוט
            </h2>

            <p className="text-slate-300">
              תנאי שימוש אלו והשימוש באתר כפופים לדיני מדינת ישראל בלבד. סמכות
              השיפוט הבלעדית בכל מחלוקת הקשורה לאתר או לשימוש בו תהא נתונה לבתי
              המשפט המוסמכים בישראל.
            </p>
          </section>
        </div>

        <div className="mt-20 pt-10 border-t border-white/10 text-center">
          <a
            href="/"
            className="inline-flex items-center gap-2 text-blue-400 font-medium
                       hover:text-blue-300 transition-colors
                       focus-visible:ring-2 focus-visible:ring-blue-500 rounded"
          >
            ← חזרה לאתר הראשי
          </a>
        </div>
      </div>
    </main>
  );
}
